import { BREAKPOINTS, isMobileViewport } from '../config/breakpoints';

const DEV_NATIVE_STORAGE_KEY = 'rintintin_dev_native_mode';

export const isMobileDevice = (): boolean => {
  return isMobileViewport(window.innerWidth);
};

interface CapacitorBridge {
  isNativePlatform?: () => boolean;
  getPlatform?: () => string;
}

function isRealNativeApp(): boolean {
  const w = window as Window & {
    Capacitor?: CapacitorBridge;
    cordova?: unknown;
  };

  if (w.Capacitor?.isNativePlatform) {
    return w.Capacitor.isNativePlatform();
  }

  if (w.cordova) return true;

  const ua = navigator.userAgent;
  if (ua.includes('CapacitorApp') || ua.includes('CordovaApp')) return true;

  const platform = w.Capacitor?.getPlatform?.();
  return platform === 'android' || platform === 'ios';
}

/**
 * Mode dev natif activé via `?native=1` (persisté en sessionStorage).
 * Uniquement en `NODE_ENV=development` — ignoré en production.
 */
export const isNativeDevMode = (): boolean => {
  if (process.env.NODE_ENV !== 'development') return false;
  try {
    return sessionStorage.getItem(DEV_NATIVE_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

/**
 * Lit `?native=1` ou `?native=0` au démarrage et persiste le choix.
 * Nettoie le paramètre de l'URL pour ne pas polluer les liens partagés.
 * À appeler une fois dans index.tsx avant le rendu React.
 */
export function initNativeDevMode(): void {
  if (process.env.NODE_ENV !== 'development') return;

  const params = new URLSearchParams(window.location.search);
  const nativeParam = params.get('native');

  if (nativeParam === null) return;

  try {
    if (nativeParam === '1') {
      sessionStorage.setItem(DEV_NATIVE_STORAGE_KEY, '1');
    } else {
      sessionStorage.removeItem(DEV_NATIVE_STORAGE_KEY);
    }
  } catch {
    // sessionStorage indisponible (mode privé strict, etc.)
  }

  params.delete('native');
  const query = params.toString();
  const cleanUrl = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
  window.history.replaceState({}, '', cleanUrl);
}

/**
 * Détecte si l'app tourne en contexte natif (Capacitor iOS/Android)
 * ou en mode dev natif simulé (`?native=1`).
 */
export const isNativeApp = (): boolean => {
  return isNativeDevMode() || isRealNativeApp();
};

export const isMobileNative = (): boolean => {
  return isMobileDevice() && isNativeApp();
};

export const shouldSkipLandingPage = (): boolean => {
  return isNativeApp();
};

/** @deprecated Préférer BREAKPOINTS.sm depuis config/breakpoints */
export const MOBILE_MAX_WIDTH = BREAKPOINTS.sm - 1;
